import { Box, Tooltip } from "@mui/material";
import { ArrowUpward, ArrowDownward } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { TbPlayerTrackPrevFilled } from 'react-icons/tb';
import { TbPlayerTrackNextFilled } from 'react-icons/tb';

const headerStyle = {
    border: "1px solid #ddd",
    padding: "10px",
    textAlign: "left",
    fontWeight: "bold",
    fontSize: "14px",
    color: "#fff",
    cursor: "pointer",
};

const cellStyle = {
    border: "1px solid #ddd",
    padding: "10px",
    textAlign: "left",
    fontSize: "12px",
};

const TaskTable = ({ employeeData, currentPage, onPageChange, onSortChange, currentOrdering }) => {

    const navigate = useNavigate();

    const data = employeeData?.project_details || [];
    const count = employeeData?.count || 0;
    const nextPage = employeeData?.next_page;
    const prevPage = employeeData?.previous_page;

    const truncate = (desc) =>
        desc?.length > 15 ? `${desc.substring(0, 15)}...` : desc;

    const handleSort = (key) => {
        let newOrdering = key;
        if (currentOrdering === key) {
            newOrdering = `-${key}`;
        } else if (currentOrdering === `-${key}`) {
            newOrdering = "";
        }
        onSortChange(newOrdering);
    };

    const handleTaskNavigate = () => {
        navigate('/project-task');
    }

    return (
        <div
            style={{
                width: "100%",
                overflowX: "auto",
                whiteSpace: "nowrap",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
            }}
        >
            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                }}
            >
                <thead>
                    <tr style={{ background: "linear-gradient(135deg, #646987 0%, #646987 100%)" }}>
                        {[
                            { key: "project_name", label: "Project" },
                            { key: "task_title", label: "Task" },
                            { key: "milestone_name", label: "Milestone" },
                            { key: "module_name", label: "Module" },
                            { key: "start_date", label: "Start Date" },
                            { key: "end_date", label: "End Date" },
                            { key: "assigned_hours", label: "Assigned Hours" },
                            { key: "actual_hours", label: "Actual Hours" },
                            { key: "status", label: "Status" },
                        ].map((col) => (
                            <th
                                key={col.key}
                                style={headerStyle}
                                onClick={() => handleSort(col.key)}
                            >
                                {col.label}{" "}
                                {currentOrdering === col.key ? (
                                    <ArrowUpward fontSize="small" />
                                ) : currentOrdering === `-${col.key}` ? (
                                    <ArrowDownward fontSize="small" />
                                ) : null}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.length === 0 ? (
                        <tr>
                            <td colSpan={9} style={{ textAlign: "center", padding: "20px", fontSize: "14px", color: "#777", fontWeight: 'bold', fontFamily: 'sans-serif', fontStyle: 'italic' }}>
                                No Task Data Found <br /> Once the task is assigned to you, task details will be displayed here.
                            </td>
                        </tr>
                    ) : (
                        data.map((row, index) => (
                            <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
                                <td style={cellStyle}>
                                    <Tooltip title={row.projectName} arrow>
                                        <span>{row.projectName}</span>
                                    </Tooltip>
                                </td>
                                <td style={cellStyle} onClick={handleTaskNavigate}>
                                    <Tooltip title={row.taskName} arrow>
                                        <span>{row.taskName}</span>
                                    </Tooltip>
                                </td>
                                <td style={cellStyle}>{truncate(row.milestone)}</td>
                                <td style={cellStyle}>{row.module}</td>
                                <td style={cellStyle}>{row.startDate}</td>
                                <td style={cellStyle}>{row.endDate}</td>
                                <td style={cellStyle}>
                                    {row.actualHours > 0 ? row.assignedHours : "N/A"}
                                </td>
                                <td style={cellStyle}>{row.actualHours}</td>
                                <td style={cellStyle}>{row.status}</td>
                            </tr>
                        ))
                    )}
                </tbody>

            </table>


            <div style={{ marginTop: "10px", display: "flex", justifyContent: "flex-end", alignItems: 'center' }}>
                <Box
                    onClick={() => prevPage && onPageChange(currentPage - 1)}
                    sx={{
                        padding: "5px",
                        borderRadius: '50%',
                        backgroundColor: prevPage ? '#646987' : '#ccc',
                        height: '30px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: prevPage ? 'pointer' : 'not-allowed'
                    }}
                >
                    <TbPlayerTrackPrevFilled size={20} color="#fff" />
                </Box>
                <span style={{ fontSize: '14px', margin: '0 10px' }}>
                    Page {currentPage} (Total: {count} items)
                </span>
                <Box
                    onClick={() => nextPage && onPageChange(currentPage + 1)}
                    sx={{
                        padding: "5px",
                        borderRadius: '50%',
                        backgroundColor: nextPage ? '#646987' : '#ccc',
                        height: '30px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: nextPage ? 'pointer' : 'not-allowed'
                    }}
                >
                    <TbPlayerTrackNextFilled size={20} color="#fff" />
                </Box>
            </div>

            <style>
                {`
          div::-webkit-scrollbar {
            display: none;
          }
        `}
            </style>
        </div>
    );
};

export default TaskTable;
